<div class="page">
  <div class="card">
    <img
      class="logo"
      [src]="'assets/scanafy_company_logo_croped.png'"
      alt="Scanafy"
    />

    <nz-result
      nzStatus="warning"
      [nzTitle]="titleKey | translate"
      [nzSubTitle]="subtitleKey | translate"
    >
      <div nz-result-extra class="actions">
        <button nz-button nzType="primary" routerLink="/mobile-desktop">
          {{ 'AUTH_LINK_ERROR.CTA_NEW_LINK' | translate }}
        </button>

        <button nz-button nzType="default" routerLink="/login">
          {{ 'AUTH_LINK_ERROR.CTA_LOGIN' | translate }}
        </button>
      </div>
    </nz-result>
  </div>
</div>
